export enum ChainId {
  MAINNET = 1,
  SEPOLIA = 11155111,
  BINANCETEST = 97,
  AMOY = 80002,
  ARBITRUM = 421614,
  FANTOM = 4002,
  AVALANCE = 43113,
  OPTIMISM = 11155420,
  LINEA = 59141,
  CELO = 44787,
  BASE = 84532,
  BLAST = 168587773,
  AURORA = 1313161555,
  SCROLL = 534351,
  MOONBASE = 1287,
}

export const supportedChainIds = Object.values(ChainId).slice(Object.values(ChainId).length / 2) as number[];
export const Router: { [chainId in ChainId]: string } = {
  1: '',
  11155111: '0x73AC342ae6492C4871fF708E3fc86e4F019EDBe9',
  97: '0xa3E1bAae8e17803c71F41E05AB5854ebF7c137F2',
  80002: '0x40b250Dc7c789F3f8f4CdEf2cE369421869eA380',
  421614: '0x9014dAE23DfB0059A0c2bc7E6503334F213A8036',
  4002: '0x40b250Dc7c789F3f8f4CdEf2cE369421869eA380',
  43113: '0xa19Ab77b849d4b2D137b0D0d148b4566183557Bc',
  11155420: '0xa1012EE0BEE96dcbC08267Fc35E6B06E64E4AC45',
  59141: '0x4cd93352D611BeDaC1E28c7C68d8BB52E35eA104',
  44787: '0x13D317e065C39a2DA9102B12FF75EE19B5EA3c15',
  84532: '0x13D317e065C39a2DA9102B12FF75EE19B5EA3c15',
  168587773: '0xa1012EE0BEE96dcbC08267Fc35E6B06E64E4AC45',
  1313161555: '0x447027b3546D9385Fb9dFF934afFAE7D0810afE0',
  534351: '0xa1012EE0BEE96dcbC08267Fc35E6B06E64E4AC45',
  1287: '0x9014dAE23DfB0059A0c2bc7E6503334F213A8036',
};

export const Factory: { [chainId in ChainId]: string } = {
  1: '',
  11155111: '0x495e261f518c42d051B3dEe8C827B6b43c1bb53E',
  97: '0xe96B698EAc8C07A6e5352BE3d492709C8aa78117',
  80002: '0xa1749f0f055c6b85e600B1303DF4EBDCB3fc9635',
  421614: '0x448e31F4682eE1bbF36aDF44cC38f7C9d84fd262',
  4002: '0x448e31f4682ee1bbf36adf44cc38f7c9d84fd262',
  43113: '0x4cd93352D611BeDaC1E28c7C68d8BB52E35eA104',
  11155420: '0xC8481648F5Ff2Fe46027a4E5B49165A55DE106Fd',
  59141: '0x4370963Dd8295d4BF309d8541CC8a5062222dE2f',
  44787: '0x9014dAE23DfB0059A0c2bc7E6503334F213A8036',
  84532: '0xC8481648F5Ff2Fe46027a4E5B49165A55DE106Fd',
  168587773: '0x01805a841ece00cf680996bF4B4e21746C68Fd4e',
  1313161555: '0xceBa082c764292e475A026BD3ED7cF89369c94cF',
  534351: '0x01805a841ece00cf680996bF4B4e21746C68Fd4e',
  1287: '0xC8481648F5Ff2Fe46027a4E5B49165A55DE106Fd',
};

export const Init_code: { [chainId in ChainId]: string } = {
  1: '',
  97: '0x628491fed98e5aae9a4cfc47624d316f017b5abdfe665003c6b9d5b8cb4663ea',
  80002: '0x45fd225de151e44f6fd8b19ee610de7fa06b924ed86b31e6f74aa9d5d0e2ee5b',
  421614: '0x628491fed98e5aae9a4cfc47624d316f017b5abdfe665003c6b9d5b8cb4663ea',
  4002: '0x628491fed98e5aae9a4cfc47624d316f017b5abdfe665003c6b9d5b8cb4663ea',
  11155111: '0x628491fed98e5aae9a4cfc47624d316f017b5abdfe665003c6b9d5b8cb4663ea',
  43113: '0x533e9fb2a4807fcffe2086e95f38f687cb0e9ea0371ab06446ce4970993bebb2',
  11155420: '0x628491fed98e5aae9a4cfc47624d316f017b5abdfe665003c6b9d5b8cb4663ea',
  59141: '0x8270d308fcd9b079c96f0f5c9ca348d65b0dad8943258ab76e0475cef640e221',
  44787: '0x628491fed98e5aae9a4cfc47624d316f017b5abdfe665003c6b9d5b8cb4663ea',
  84532: '0x628491fed98e5aae9a4cfc47624d316f017b5abdfe665003c6b9d5b8cb4663ea',
  168587773: '0x628491fed98e5aae9a4cfc47624d316f017b5abdfe665003c6b9d5b8cb4663ea',
  1313161555: '0x8270d308fcd9b079c96f0f5c9ca348d65b0dad8943258ab76e0475cef640e221',
  534351: '0x628491fed98e5aae9a4cfc47624d316f017b5abdfe665003c6b9d5b8cb4663ea',
  1287: '0x628491fed98e5aae9a4cfc47624d316f017b5abdfe665003c6b9d5b8cb4663ea',
};

export const Network_Url: { [chainId in ChainId]: string } = {
  1: '',
  97: 'https://rpc.ankr.com/bsc_testnet_chapel/',
  80002: 'https://rpc.ankr.com/polygon_amoy',
  421614: 'https://rpc.ankr.com/arbitrum_sepolia',
  4002: 'https://rpc.testnet.fantom.network',
  11155111: 'https://rpc.ankr.com/eth_sepolia',
  43113: 'https://rpc.ankr.com/avalanche_fuji',
  11155420: 'https://rpc.ankr.com/optimism_sepolia',
  59141: 'https://linea-sepolia.infura.io/v3/',
  44787: 'https://alfajores-forno.celo-testnet.org',
  84532: 'https://rpc.ankr.com/base_sepolia',
  168587773: 'https://rpc.ankr.com/blast_testnet_sepolia',
  1313161555: 'https://aurora-testnet.drpc.org',
  534351: 'https://rpc.ankr.com/scroll_sepolia_testnet',
  1287: 'https://rpc.testnet.moonbeam.network',
};
